import {
  MERGE_SALE_LOT_COMMIT,
  MERGE_SALE_LOT_OFFLINE,
  MERGE_SALE_LOT_ROLLBACK,
} from "constants/actionTypes";

export function saleLotsMerge(fromSaleLotIds: string[], toSaleLotId: string) {
  return {
    type: MERGE_SALE_LOT_OFFLINE,
    payload: { fromSaleLotIds, toSaleLotId },
    meta: {
      offline: {
        effect: {
          url: `/v2/salelots/${toSaleLotId}/merge`,
          method: "POST",
          body: JSON.stringify({ from_sale_lot_ids: fromSaleLotIds }),
        },
        commit: {
          type: MERGE_SALE_LOT_COMMIT,
        },
        rollback: {
          type: MERGE_SALE_LOT_ROLLBACK,
          meta: { fromSaleLotIds, toSaleLotId },
        },
      },
    },
  };
}
